import React from "react";
import { CheckCircle2 } from "lucide-react";

const SectionHeading = ({ eyebrow, title, subtitle, center = true, light = false }) => {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-12`}>
      {eyebrow && (
        <span className={`inline-flex items-center gap-2 font-semibold text-sm px-4 py-1.5 rounded-full ${light ? "text-sky-100 bg-white/10" : "text-sky-600 bg-sky-50"}`}>
          <CheckCircle2 size={16} /> {eyebrow}
        </span>
      )}
      <h2 className={`font-heading text-3xl sm:text-4xl font-bold mt-4 ${light ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg ${light ? "text-sky-100" : "text-slate-500"}`}>{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;
